import Request from '@/utils/request'

// 自定义图片页面
export function getCustomImgPageCfg(params) {
  return Request({
    url: '/api/v2/app/h5CommPageConf/image',
    method: 'get',
    params,
  })
}
